import Modal from '@/components/modals/modal/modal.vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import CurrencyFormatInputEdit from '@/components/currency-format-input-edit/currency-format-input-edit.vue'
import emitHideMixin from '@/components/modals/mixins/emit-hide'

export default {
  name: 'CreateEncashmentModal',
  /**
   * методы hide и onHideModal
   */
  mixins: [emitHideMixin],
  props: {
    amountForEncashment: {
      type: Number,
      default: 0
    },
    /**
     * при 0 - отключена валидация на минимальное значение
     */
    minAmount: {
      type: Number,
      default: 100
    },
    isFinal: {
      type: Boolean,
      default: false
    },
    isEditEncashment: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Modal,
    ValidationObserver,
    ValidationProvider,
    CurrencyFormatInputEdit
  },
  data() {
    return {
      form: {
        amount: 0
      }
    }
  },
  methods: {
    show () {
      this.$refs.modal.show()
      this.form.amount = this.amountForEncashment
    },
    
    /**
     * Закрывать из компонента-родителя
     */
    onSubmit() {
      this.$refs['observer'].validate().then(async success => {
        if (success) {
          this.$emit('create-encashment', this.form)
        }
      })
    }
  }
}